import React from 'react';
import PropTypes from 'prop-types';
import { Container } from 'react-bootstrap';

import { getContentBlockItemValue } from '../../../CmsActions.js';

import ReviewSummary from '../../../../Review/components/view/ReviewSummary.js';

// Thin CMS wrapper around the existing ReviewSummary component so customer reviews can be dropped
// into a page via the `panel` content block. Data loading is handled by ReviewSummary itself
// (same behaviour as HomePage / ProductViewPage usages).
function PanelReviews({ panel }) {
    const title = getContentBlockItemValue(panel.blocks, 'title');
    const hideSummary = Boolean(getContentBlockItemValue(panel.blocks, 'hideSummary', 'value'));
    const hideQuestions = Boolean(getContentBlockItemValue(panel.blocks, 'hideQuestions', 'value'));
    const hideTitle = Boolean(getContentBlockItemValue(panel.blocks, 'hideTitle', 'value'));
    const countPerSlide = parseInt(getContentBlockItemValue(panel.blocks, 'countPerSlide'), 10) || undefined;

    return (
        <Container className="py-2">
            {title && <h3 className="border-half-light text-primary text-center">{title}</h3>}
            <ReviewSummary
                isRandom
                hideSummary={hideSummary}
                hideQuestions={hideQuestions}
                hideTitle={hideTitle}
                countPerSlide={countPerSlide}
            />
        </Container>
    );
}

PanelReviews.propTypes = {
    panel: PropTypes.object.isRequired,
};

export default PanelReviews;
